import { useEffect, useRef, useState } from 'react'

export function SlideTitle({ lines, className = 'slide-title' }: { lines: string[]; className?: string }) {
  const wrapRef = useRef<HTMLDivElement>(null)
  const titleRef = useRef<HTMLHeadingElement>(null)
  const [fs, setFs] = useState<number | null>(null)

  useEffect(() => {
    const wrap = wrapRef.current
    const title = titleRef.current
    if (!wrap || !title) return

    const fit = () => {
      const avail = wrap.clientWidth
      if (!avail) return
      const spans = Array.from(title.querySelectorAll<HTMLElement>('.lt'))
      if (!spans.length) return

      const prevFs = title.style.fontSize
      title.style.fontSize = '100px'
      spans.forEach((s) => (s.style.display = 'inline'))

      let maxW = 0
      spans.forEach((s) => { maxW = Math.max(maxW, s.getBoundingClientRect().width) })

      title.style.fontSize = prevFs
      spans.forEach((s) => (s.style.display = ''))

      if (!maxW) return
      const computed = Math.min(220, Math.max(28, Math.floor((avail / maxW) * 100 * 0.97)))
      setFs(computed)
    }

    fit()
    const ro = new ResizeObserver(fit)
    ro.observe(wrap)
    return () => ro.disconnect()
  }, [lines])

  return (
    <div ref={wrapRef} style={{ width: '100%' }}>
      <h1 ref={titleRef} className={className} style={fs != null ? { fontSize: fs } : undefined}>
        {lines.map((line, li) => (
          <span key={li} className="lt">{line}</span>
        ))}
      </h1>
    </div>
  )
}
